import React from 'react';
import PropTypes from 'prop-types';
import PopupContent from 'new-ui/Components/Popup/PopupContent';
import { useTranslation } from 'utils/modifiedTranslation';
import './index.css';

const PREFERENCE_PREFERRED_THERAPHY = 'preferred_intervention';
const PREFERENCE_PREFERRED_IN_SOME_CASES = 'preferred_in_certain_circumstances';
const PREFERENCE_OTHER_RECOMENDED_THERAPY = 'other_recommended_intervention';
const PREFERENCE_USEFUL_IN_CERTAIN_CIRCUMSTANCES = 'useful_in_certain_circumstances';
const PREFERENCE_SUPPORTIVE = 'supportive_care';

const POPUP_PREFERENCES = [
  PREFERENCE_PREFERRED_THERAPHY,
  PREFERENCE_PREFERRED_IN_SOME_CASES,
  PREFERENCE_OTHER_RECOMENDED_THERAPY,
  PREFERENCE_USEFUL_IN_CERTAIN_CIRCUMSTANCES,
  PREFERENCE_SUPPORTIVE,
];

const EVIDENCES = [
  '1', '2A', '2B', '3',
];

const PreferenceCategory = ({ preference, evidence }) => {
  const { t } = useTranslation();

  return (
    <PopupContent>
      <div className="preference-popup">
        <h3>{t('match.category_of_preference.popup.title')}</h3>
        {POPUP_PREFERENCES.map((value) => (
          <div
            key={value}
            className={preference === value ? 'active' : ''}
          >
            <p className="title">
              {t(`match.list.item.treatment.category_of_preference.title.${value}`)}
            </p>
            <p className="description">
              {t(`match.list.item.treatment.category_of_preference.description.${value}`)}
            </p>
          </div>
        ))}
        <h3>{t('match.category_of_evidence.popup.title')}</h3>
        {EVIDENCES.map((value) => (
          <div
            key={value}
            className={evidence === value ? 'active' : ''}
          >
            <p className="title">
              {t(`match.list.item.treatment.category_of_evidence.title.${value}`)}
            </p>
            <p className="description">
              {t(`match.list.item.treatment.category_of_evidence.description.${value}`)}
            </p>
          </div>
        ))}
      </div>
    </PopupContent>
  );
};

PreferenceCategory.propTypes = {
  preference: PropTypes.string,
  evidence: PropTypes.string,
};

export default PreferenceCategory;
